import { StyledIcon } from './ImgIcon.styled';

interface IImgIconProps {
	icon: string;
	width?: number;
	height?: number;
	color?: string;
}

const ImgIcon = ({
	icon,
	width,
	height,
	color,
	...props
}: IImgIconProps & React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<StyledIcon
			className="img-icon"
			$icon={icon}
			$width={width}
			$height={height}
			$color={color}
			{...props}
		/>
	);
};

export { ImgIcon };
